/*
 * @Author: Teemo Ding
 * @Date: 2022-02-15 09:53:52
 * @LastEditTime: 2022-05-07 16:16:40
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/communication.ts
 */

export enum CommunicationGatewayProvider {
  Twilio = 'Twilio',
  Sendgrid = 'Sendgrid',
  Tencent = 'Tencent',
  Cloopen = 'Cloopen',
  Zhima = 'Zhima',
}
export enum CommunicationChannelTypeMp {
  WechatMP = 'WechatMP',
}

export enum CommunicationChannelType {
  SMS = 'SMS',
  WhatsApp = 'WhatsApp',
  WechatMP = 'WechatMP',
  LiveChat = 'LiveChat',
  Email = 'Email',
  CoolpenSms = 'CoolpenSms',
  PhoneNumberValidation = 'PhoneNumberValidation',
}

export enum SendFromType {
  Mobile = 'Mobile',
  SenderId = 'SenderId',
}

export enum DestinationType {
  Mainland = 'Mainland',
  NonMainland = 'NonMainland',
}

export enum CategoryGroupType {
  Order = 'Order',
  Fulfillment = 'Fulfillment',
  Product = 'Product',
  Customer = 'Customer',
}

export enum LogStatus {
  Pending = 'Pending',
  Sent = 'Sent',
  Failed = 'Failed',
}
